module.exports = __webpack_public_path__ + "static/media/pink_animal_birds.5ba77c0b.webp";